import { combineReducers } from '@reduxjs/toolkit';
import assetsSlice from './slice';
import { domainReducers } from './domains';

export default combineReducers({
  entity: assetsSlice.reducer,
  domains: domainReducers,
});
